<template>
    <div class="content-wrapper trips-index-page">
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <app-breadcrumb :page-title="$t('trackings')" :icon="'map'" />
            </div>
            <div class="col-sm-12 col-md-9 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0 d-flex flex-wrap justify-content-md-end align-items-center">
                    <button
                        v-if="!isConvoyMode"
                        type="button"
                        class="btn btn-with-shadow mb-2 mb-md-0"
                        :class="isLiveTrackingOnly ? 'btn-success' : 'btn-outline-success'"
                        @click="toggleLiveTrackingOnly">
                        <app-icon name="map-pin" class="size-20 mr-2" />
                        {{ $t('live_tracking') }}
                    </button>
                    <div class="btn-group ml-2 mr-2 mb-2 mb-md-0" role="group">
                        <button
                            type="button"
                            class="btn"
                            :class="isConvoyMode ? 'btn-outline-primary' : 'btn-primary'"
                            @click="setViewMode('listing')"
                        >
                            {{ $t('listing_mode') }}
                        </button>
                        <button
                            v-if="$can('view_convoys')"
                            type="button"
                            class="btn"
                            :class="isConvoyMode ? 'btn-primary' : 'btn-outline-primary'"
                            @click="setViewMode('convoy')"
                        >
                            {{ $t('convoy_mode') }}
                        </button>
                        <a
                            :href="controlRoomUrl"
                            class="btn btn-outline-primary"
                        >
                            {{ $t('control_mode') }}
                        </a>
                    </div>
                    <button
                        v-if="isConvoyMode && $can('create_convoys')"
                        type="button"
                        class="btn btn-primary btn-with-shadow ml-2 mb-2 mb-md-0"
                        @click="openConvoyModal('', [])"
                    >
                        <app-icon name="plus" class="size-20 mr-2" />
                        {{ $t('new_convoy') }}
                    </button>
                    <button type="button" class="btn btn-primary btn-with-shadow ml-2" data-toggle="modal"
                        @click="openAddEditModal" v-if="!isConvoyMode && this.$can('create_trips')">
                        <app-icon name="plus" class="size-20 mr-2" />
                        {{ `${this.$t('new_tracking')}` }}
                    </button>
                    <button
                        v-if="!isConvoyMode && selectedConvoyAction"
                        type="button"
                        class="btn btn-outline-primary btn-with-shadow ml-2"
                        @click="openConvoyModal(selectedConvoyAction.url, selectedTrips)"
                    >
                        <app-icon name="layers" class="size-20 mr-2" />
                        {{ selectedConvoyAction.label }}
                    </button>
                    <button
                        v-if="canBulkUpdateSelectedTrips"
                        type="button"
                        class="btn btn-outline-primary btn-with-shadow ml-2"
                        @click="openBulkTruckEventModal"
                    >
                        <app-icon name="edit-3" class="size-20 mr-2" />
                        {{ $t('change_selected_trucks_position') }}
                    </button>
                    <button type="button" class="btn btn-with-shadow ml-2 trips-index-page__excel-export" @click="exportTrips()"
                        v-if="!isConvoyMode && this.$can('manage_export_trips') && hasActiveExportFilters">
                        <app-icon name="file" class="size-20 mr-2" />
                        {{ $t('excel_export') }}
                    </button>
                    <!-- <input type="file" @change="handleFileUpload" ref="fileInput" style="display: none;" />
                    <button type="button" class="btn btn-info btn-with-shadow ml-2" :title="selectedImport?.name"
                        @click="selectedImport?.name.length > 0 ? submitFile() : triggerFileInput()"
                        v-if="this.$can('view_settings')">
                        <app-icon name="download" class="size-20" />
                        {{ shortenFileName(selectedImport?.name, 10, 10) }}
                    </button>
                    <button type="button" v-if="selectedImport?.name.length > 0"
                        class="btn btn-danger btn-with-shadow ml-2" @click="selectedImport = {name:''}">
                        <app-icon name="trash" class="size-20" />
                    </button> -->
                </div>
            </div>
        </div>

        <app-table v-if="!isConvoyMode" :id="tableId" :options="options" row-density="compact"
            @getFilteredValues="setActiveFilterValues"
            @action="getListAction" @getRows="getSelectedRows" />
        <app-table v-else :id="convoyTableId" :options="convoyOptions" row-density="compact"
            @action="getConvoyListAction" />

        <trip-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" @openEscorterModal="openEscorterAddModal" />

        <convoy-add-edit-modal
            v-if="isConvoyModalActive"
            :selected-url="selectedConvoyUrl"
            :selected-trips="convoyModalTrips"
            :read-only="convoyModalReadOnly"
            :trip-table-id="tableId"
            :convoy-table-id="convoyTableId"
            @close-modal="closeConvoyModal"
        />

        <trip-device-assignment-modal v-if="isTripDeviceAssignmentModalActive" :table-id="tableId"
            :trip-data="tripDeviceData" @close-modal="closeTripDeviceAssignmentModal" />

        <bulk-truck-event-modal
            v-if="isBulkTruckEventModalActive"
            :table-id="tableId"
            :trips="selectedTrips"
            @close-modal="closeBulkTruckEventModal"
        />

        <add-truck-event-modal v-if="isTruckEventModalActive" :table-id="tableId" :truckData="truckData"
            @close-modal="closeTruckEventModal" />

        <event-timeline-modal v-if="isEventTimelineModalActive" :timelineData="timelineData"
            @close-modal="closeEventTimelineModal" />

        <escorter-modal v-if="isEscorterModalActive" :escorterData="escorterData" @close-modal="closeEscorterModal" />

        <escorter-add-edit-modal v-if="escorterAddModalActive" :table-id="tableId"
            @close-modal="closeEscorterAddModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="trip-delete"
            @confirmed="confirmed" @cancelled="cancelled" />

        <app-delete-modal v-if="convoyDeleteConfirmationModalActive" :preloader="convoyDeleteLoader" modal-id="convoy-delete"
            @confirmed="confirmedConvoyDelete" @cancelled="cancelledConvoyDelete" />

        <trip-context-menu v-if="!isConvoyMode && isContextMenuOpen" :trips="selectedTrips"
            @close="isContextMenuOpen = false" />
    </div>
</template>

<script>
import axios from 'axios';
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import AppFunction from '../../../../core/helpers/app/AppFunction';
import * as actions from "../../../Config/ApiUrl";
import { formatDateToLocal, numberFormatter } from '../../../Helpers/Helpers';
import { siteTrip, productTrip, transporterTrip,
        locationTrip, statusTrip, clientTrip,
        escorterTrip, destinationTrip, transitTrip,
        vehiculeTrip, userTrip } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [siteTrip, productTrip, transporterTrip, locationTrip,
                statusTrip, escorterTrip, clientTrip, destinationTrip,
        transitTrip, vehiculeTrip, userTrip],
    name: "AppTrips",
    data() {
        return {
            truckData: {},
            escorterData: {},
            timelineData: {},
            isTruckEventModalActive: false,
            isEventTimelineModalActive: false,
            isAddEditModalActive: false,
            isConvoyModalActive: false,
            isTripDeviceAssignmentModalActive: false,
            isBulkTruckEventModalActive: false,
            isEscorterModalActive: false,
            escorterAddModalActive: false,
            deleteConfirmationModalActive: false,
            convoyDeleteConfirmationModalActive: false,
            datatableWrapper: true,
            deleteLoader: false,
            convoyDeleteLoader: false,
            selectedUrl: '',
            selectedConvoyUrl: '',
            tableId: 'trips-table',
            convoyTableId: 'convoys-table',
            rowData: {},
            convoyRowData: {},
            tripDeviceData: {},
            selectedTrips: [],
            convoyModalTrips: [],
            convoyModalReadOnly: false,
            isContextMenuOpen: false,
            activeFilterValues: {},
            filteredTripsTotal: 0,
            viewMode: this.$can('view_convoys') ? 'listing' : 'listing',
            selectedImport: {
                name: '',
            },
            options: {
                name: 'AppTrips',
                url: actions.TRIP,
                showHeader: true,
                enableHighlights: false,
                enableSaveFilter: true,
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                primaryFilterCount: 4,
                primaryFilters: ['dispatched_at', 'loading_date', 'exit_date', 'clients'],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                paginationOptions: [10, 20, 30, 100, 500, 1000],
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                afterRequestSuccess: ({ data }) => {
                    this.filteredTripsTotal = Number(data?.total || 0);
                },
                afterRequestError: () => {
                    this.filteredTripsTotal = 0;
                },

                filters: [
                    {
						title: this.$t('Dispatch'),
						type: "range-picker",
						key: "dispatched_at",
						option: ["nothing","today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
					},
                    {
                        title: this.$t('Loading'),
                        type: "range-picker",
                        key: "loading_date",
                        option: ["nothing", "today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t('exit_date'),
                        type: "range-picker",
                        key: "exit_date",
                        option: ["nothing", "today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t("client"),
                        type: "multi-select-filter",
                        key: "clients",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("site"),
                        type: "multi-select-filter",
                        key: "sites",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("product"),
                        type: "multi-select-filter",
                        key: "products",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("vehicule_type"),
                        type: "multi-select-filter",
                        key: "vehicules",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("transporter"),
                        type: "multi-select-filter",
                        key: "transporters",
                        option: [],
                        permission: true
                    },
                    // {
                    //     title: this.$t("location"),
                    //     type: "multi-select-filter",
                    //     key: "locations",
                    //     option: [],
                    //     permission: true
                    // },
                    {
                        title: this.$t("trip_status"),
                        type: "multi-select-filter",
                        key: "status",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("destination"),
                        type: "multi-select-filter",
                        key: "destinations",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("device_assignment"),
                        type: "drop-down-filter",
                        key: "device_assignment",
                        option: [
                            { id: 'assigned', value: this.$t('assigned') },
                            { id: 'unassigned', value: this.$t('unassigned') },
                        ],
                    },
                    {
                        title: this.$t("convoy_assignment"),
                        type: "drop-down-filter",
                        key: "convoy_assignment",
                        option: [
                            { id: 'in_convoy', value: this.$t('in_convoy') },
                            { id: 'solo', value: this.$t('solo') },
                        ],
                    },
                    // {
                    //     "title": this.$t('created_at'),
                    //     "type": "range-picker",
                    //     "key": "created_at",
                    //     "option": ["nothing", "today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    // },
                    // {
                    //     title: this.$t('created_by'),
                    //     type: "drop-down-filter",
                    //     key: "createdBy",
                    //     option: [],
                    //     permission: this.$can('view_users')
                    // },
                ],
                columns: [
                    {
                        title: this.$t('lot_number'),
                        type: 'custom-html',
                        key: 'lot_number',
                        modifier: (value, row) => {
                            return value ? `<b>${value}</b>` : '';
                        }
                    },
                    {
                        title: this.$t('Live Location'),
                        type: 'component',
                        key: 'active_device_name',
                        componentName: 'trip-device-cell',
                    },
                    {
                        title: this.$t('convoy'),
                        type: 'component',
                        key: 'convoy_code',
                        componentName: 'trip-convoy-cell',
                    },
                    {
                        title: this.$t('product'),
                        type: 'text',
                        key: 'product_name',
                    },

                    {
                        title: this.$t('client'),
                        type: 'text',
                        key: 'client_name',
                    },
                    {
                        title: this.$t('site'),
                        type: 'text',
                        key: 'site_name',
                    },
                    {
                        title: this.$t('trip_status'),
                        type: 'custom-html',
                        key: 'status',
                        modifier: (value, row) => {
                            return row.status_name ? `<span class="badge badge-${row.status_type} badge-pill mr-2">${row.status_name}</span>` : '';
                        }
                    },
                    {
                        title: this.$t('loading_date'),
                        type: 'object',
                        key: 'loading_date',
                        sortable: true,
                        modifier: (loading_date => loading_date ? formatDateToLocal(loading_date) : '---')
                    },
                    {
                        title: this.$t('dispatched_at'),
                        type: 'object',
                        key: 'dispatched_at',
                        sortable: true,
                        modifier: (dispatched_at => dispatched_at ? formatDateToLocal(dispatched_at) : '---')
                    },
                    {
                        title: this.$t('location'),
                        type: this.$can('manual_tracker_entry') || this.$can('create_trackings')
                            ? 'button'
                            : 'text',
                        key: 'location_name',
                        className: this.$can('manual_tracker_entry') || this.$can('create_trackings')
                            ? 'btn btn-sm btn-primary rounded-pill px-3 py-1'
                            : '',
                        modifier: (value, row) => {
                            return row.location_name || '---';
                        }
                    },
                    {
                        title: this.$t('vehicule_type'),
                        type: 'text',
                        key: 'vehicule_type_name',
                    },
                    {
                        title: this.$t('transporter'),
                        type: 'text',
                        key: 'transporter_name',
                    },
                    {
                        title: this.$t('horse'),
                        type: 'text',
                        key: 'horse',
                    },
                    // {
                    //     title: this.$t('escorter'),
                    //     type: 'button',
                    //     key: 'escorter',
                    //     className: 'btn btn-sm btn-secondary rounded-pill px-3 py-1',
                    //     modifier: (value, row) => {
                    //         return row.escorter_first_name ? `${row.escorter_first_name} ${row.escorter_middle_name} ${row.escorter_last_name}` : '';
                    //     }
                    // },
                    {
                        title: this.$t('bundles'),
                        type: 'text',
                        sortable: true,
                        key: 'bundles',
                    },
                    {
                        title: this.$t('net_weight'),
                        type: 'object',
                        sortable: true,
                        key: 'net_weight',
                        modifier: (net_weight => net_weight)
                    },
                    // {
                    //     title: this.$t('gross_weight'),
                    //     type: 'object',
                    //     sortable: true,
                    //     key: 'gross_weight',
                    //     modifier: (gross_weight => gross_weight)
                    // },
                    {
                        title: this.$t('destination'),
                        type: 'text',
                        key: 'destination_name',
                    },
                    {
                        title: this.$t('exit_date'),
                        type: 'object',
                        key: 'exit_date',
                        sortable: true,
                        modifier: (exit_date => exit_date ? formatDateToLocal(exit_date) : '---')
                    },
                    // {
                    //     title: this.$t('created_at'),
                    //     type: 'object',
                    //     key: 'created_at',
                    //     sortable: true,
                    //     modifier: (created_at => created_at ? formatDateToLocal(created_at, true) : '---')
                    // },
                    // {
                    //     title: this.$t('created_by'),
                    //     type: 'object',
                    //     key: 'user',
                    //     modifier: (value, row) => {
                    //         return row.user_first_name ? `${row.user_first_name} ${row.user_last_name}` : '';
                    //     }
                    // },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'app-add-modal',
                        modalId: 'demo-add-edit-Modal',
                        modifier: () => this.$can('update_trips'),
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'trip-delete',
                        modifier: () => this.$can('delete_trips'),
                    },
                    {
                        title: this.$t('assign_device'),
                        icon: 'plus',
                        type: 'none',
                        modifier: () => this.$can('assign_device_trips'),
                    },
                    {
                        title: this.$t('tracking_timeline'),
                        icon: 'clock',
                        type: 'none',
                        modifier: () => this.$can('view_trackings'),
                    },
                    {
                        title: this.$t('unassign_device'),
                        icon: 'x',
                        type: 'none',
                        modifier: (rowData) => this.$can('unassign_device_trips') && Number(rowData.active_device_count || 0) > 0,
                    }
                ],
            }
            ,
            convoyOptions: {
                name: 'AppConvoys',
                url: actions.CONVOY,
                showHeader: true,
                enableHighlights: false,
                enableSaveFilter: true,
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                primaryFilterCount: 4,
                primaryFilters: ['convoy_status', 'clients', 'sites', 'destinations'],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                paginationOptions: [10, 20, 30, 100],
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                filters: [
                    {
                        title: this.$t("client"),
                        type: "multi-select-filter",
                        key: "clients",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("site"),
                        type: "multi-select-filter",
                        key: "sites",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("destination"),
                        type: "multi-select-filter",
                        key: "destinations",
                        option: [],
                        permission: true
                    },
                    {
                        title: this.$t("convoy_status"),
                        type: "drop-down-filter",
                        key: "convoy_status",
                        option: [
                            { id: 'active', value: this.$t('active') },
                            { id: 'paused', value: this.$t('paused') },
                            { id: 'completed', value: this.$t('completed') },
                            { id: 'dissolved', value: this.$t('dissolved') },
                        ],
                    },
                ],
                columns: [
                    {
                        title: this.$t('convoy_code'),
                        type: 'custom-html',
                        key: 'code',
                        modifier: (value) => `<strong>${value}</strong>`
                    },
                    {
                        title: this.$t('master_truck'),
                        type: 'custom-html',
                        key: 'master_lot_number',
                        modifier: (value, row) => {
                            return `
                                <div class="d-flex flex-column">
                                    <strong>${row.master_lot_number || '---'}</strong>
                                    <small class="text-muted">${row.master_horse || '---'}</small>
                                </div>
                            `;
                        }
                    },
                    {
                        title: this.$t('client'),
                        type: 'text',
                        key: 'client_name',
                    },
                    {
                        title: this.$t('site'),
                        type: 'text',
                        key: 'site_name',
                    },
                    {
                        title: this.$t('destination'),
                        type: 'text',
                        key: 'destination_name',
                    },
                    {
                        title: this.$t('convoy_members'),
                        type: 'custom-html',
                        key: 'members_summary',
                        modifier: (value, row) => {
                            const renderedMembers = (row.members || [])
                                .map((member) => {
                                    const badgeClass = member.role === 'master'
                                        ? 'badge-warning'
                                        : 'badge-light';

                                    return `<span class="badge ${badgeClass} mr-1 mb-1">${member.lot_number || '---'}</span>`;
                                })
                                .join('');

                            return renderedMembers || '<span class="text-muted">---</span>';
                        }
                    },
                    {
                        title: this.$t('trip_count'),
                        type: 'text',
                        key: 'active_trip_count',
                    },
                    {
                        title: this.$t('convoy_status'),
                        type: 'custom-html',
                        key: 'status',
                        modifier: (value, row) => {
                            const badgeMap = {
                                active: 'success',
                                paused: 'warning',
                                completed: 'secondary',
                                dissolved: 'danger',
                            };

                            return `<span class="badge badge-${badgeMap[row.status] || 'primary'} badge-pill">${this.$t(row.status)}</span>`;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        modifier: () => this.$can('update_convoys'),
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        modifier: () => this.$can('delete_convoys'),
                    }
                ],
            }
        }
    },
    computed: {
        companyName() {
            return this.$store.state.settings.appSettings?.brand_name || 'BRAS SECURITY';
        },
        applicationName() {
            return this.$store.state.settings.appSettings?.app_name || 'Escort System';
        },
        isConvoyMode() {
            return this.viewMode === 'convoy';
        },
        hasActiveExportFilters() {
            return this.filteredTripsTotal > 0
                && Object.values(this.activeFilterValues).some((value) => this.hasMeaningfulFilterValue(value));
        },
        selectedConvoyAction() {
            if (this.selectedTrips.length < 1) {
                return null;
            }

            const convoyIds = this.selectedTrips
                .map(({ convoy_id }) => convoy_id)
                .filter((id) => id !== null && id !== undefined && id !== '');

            const uniqueConvoyIds = [...new Set(convoyIds)];

            if (uniqueConvoyIds.length > 1) {
                return null;
            }

            if (uniqueConvoyIds.length === 1) {
                if (!this.$can('update_convoys')) {
                    return null;
                }

                const selectedConvoyId = uniqueConvoyIds[0];
                const hasSelectedMaster = this.selectedTrips.some((trip) => {
                    return String(trip.convoy_id || '') === String(selectedConvoyId)
                        && trip.convoy_role === 'master';
                });

                if (!hasSelectedMaster) {
                    return null;
                }

                return {
                    url: `${actions.CONVOY}/${selectedConvoyId}`,
                    label: this.$t('update_convoy'),
                };
            }

            if (!this.$can('create_convoys')) {
                return null;
            }

            return {
                url: '',
                label: this.$t('create_convoy'),
            };
        },
        isLiveTrackingOnly() {
            return this.activeFilterValues.device_assignment === 'assigned';
        },
        canBulkUpdateSelectedTrips() {
            return !this.isConvoyMode
                && this.selectedTrips.length > 1
                && (this.$can('manual_tracker_entry') || this.$can('create_trackings'));
        },
        controlRoomUrl() {
            return AppFunction.getAppUrl('app-control-trackings');
        }
    },
    watch: {
        'clients.length': {
            handler() {
                this.setFilterOptions(this.convoyOptions, 'clients', this.clients);
            },
            immediate: true,
        },
        'sites.length': {
            handler() {
                this.setFilterOptions(this.convoyOptions, 'sites', this.sites);
            },
            immediate: true,
        },
        'destinations.length': {
            handler() {
                this.setFilterOptions(this.convoyOptions, 'destinations', this.destinations);
            },
            immediate: true,
        },
    },
    methods: {
        setViewMode(mode) {
            if (mode === 'convoy' && !this.$can('view_convoys')) {
                return;
            }

            this.viewMode = mode;
        },
        setFilterOptions(targetOptions, key, entries) {
            const filter = targetOptions?.filters?.find((item) => item.key === key);

            if (filter) {
                filter.option = [...entries];
            }
        },
        setActiveFilterValues(values = {}) {
            this.activeFilterValues = { ...values };

            if (!Object.values(this.activeFilterValues).some((value) => this.hasMeaningfulFilterValue(value))) {
                this.filteredTripsTotal = 0;
            }
        },
        toggleLiveTrackingOnly() {
            const url = new URL(window.location.href);
            const key = 'device_assignment';
            const value = this.isLiveTrackingOnly ? null : 'assigned';

            if (value === null || value === undefined || value === '') {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }

            url.searchParams.delete('page');

            window.location.assign(url.toString());
        },
        hasMeaningfulFilterValue(value) {
            if (Array.isArray(value)) {
                return value.length > 0;
            }

            if (value && typeof value === 'object') {
                return Object.values(value).some((item) => this.hasMeaningfulFilterValue(item));
            }

            if (typeof value === 'string') {
                return value.trim() !== '';
            }

            if (typeof value === 'number') {
                return !Number.isNaN(value);
            }

            if (typeof value === 'boolean') {
                return value;
            }

            return value !== null && value !== undefined;
        },
        initializeActiveFiltersFromQuery() {
            const searchParams = new URLSearchParams(window.location.search);
            const filterKeys = (this.options.filters || [])
                .filter((filter) => this.isUndefined(filter.permission) || filter.permission)
                .map((filter) => _.snakeCase(_.lowerCase(filter.key)));
            const activeFilters = {};

            filterKeys.forEach((key) => {
                const value = searchParams.get(key);

                if (value !== null && value !== '') {
                    activeFilters[key] = value;
                }
            });

            this.activeFilterValues = activeFilters;
        },
        exportTrips() {
            const params = new URLSearchParams(window.location.search);

            Object.entries(this.activeFilterValues).forEach(([key, value]) => {
                const serializedValue = this.serializeExportFilterValue(value);

                if (serializedValue === null) {
                    params.delete(key);
                    return;
                }

                params.set(key, serializedValue);
            });

            const queryString = params.toString();
            window.open(AppFunction.getAppUrl(`export-trips${queryString ? `?${queryString}` : ''}`));
        },
        serializeExportFilterValue(value) {
            if (!this.hasMeaningfulFilterValue(value)) {
                return null;
            }

            if (Array.isArray(value)) {
                return value.join(',');
            }

            if (value && typeof value === 'object') {
                return JSON.stringify(value);
            }

            return String(value);
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        closeEscorterAddModal() {
            this.escorterAddModalActive = false;
            this.$store.dispatch('getEscorters');
            setTimeout(() => {
                $('#trip-add-edit-modal').css({
                    opacity: '1',
                });
            });
            $("#escorter-add-edit-modal").modal("hide");
        },
        openEscorterAddModal() {
            this.escorterAddModalActive = true;
            setTimeout(() => {
                $('#trip-add-edit-modal').css({
                    opacity: '0.5',
                });
            });
        },
        submitFile() {
            const formData = new FormData();
            formData.append('file', this.selectedImport);

            axios.post('import-trips', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                this.$toastr.s(response.data.message);
                this.selectedImport = { name:'' };
            }).catch(error => {
                console.log(error.response.data.message)
                this.$toastr.e(`System error: ${error.response.data.message}`);
            });
        },
        handleFileUpload(event) {
            this.selectedImport = event.target.files[0];
            event.target.value = null;
        },
        shortenFileName(fileName, startLength, endLength) {
            if (fileName.length > startLength + endLength + 4) {
                // Extract the start and end parts of the fileName
                const startPart = fileName.slice(0, startLength);
                const endPart = fileName.slice(-endLength);
                // Return the combined new fileName
                return `${startPart}....${endPart}`;
            } else {
                // Return the original fileName if it's short enough
                return fileName;
            }
        },
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openConvoyModal(selectedUrl = '', trips = null, readOnly = false) {
            this.selectedConvoyUrl = selectedUrl;
            this.convoyModalTrips = Array.isArray(trips) ? [...trips] : [];
            this.convoyModalReadOnly = readOnly;
            this.isConvoyModalActive = true;
        },
        closeConvoyModal() {
            this.isConvoyModalActive = false;
            this.selectedConvoyUrl = '';
            this.convoyModalTrips = [];
            this.convoyModalReadOnly = false;
        },

        openTripDeviceAssignmentModal() {
            this.isTripDeviceAssignmentModalActive = this.$can('assign_device_trips')
                || this.$can('unassign_device_trips');
        },

         /**
        * for open escorter modal
        */
        openEscorterModal() {
            this.isEscorterModalActive = true;
        },

        /**
        * for open truck event modal
        */
        openTruckEventModal() {
            this.isTruckEventModalActive = this.$can('manual_tracker_entry') || this.$can('create_trackings');
        },

        /**
        * for open truck event modal
        */
        openEventTimelineModal() {
            this.isEventTimelineModalActive = this.$can('view_trackings');
        },


        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            $("#trip-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        closeTripDeviceAssignmentModal() {
            $("#trip-device-assignment-modal").modal('hide');
            this.isTripDeviceAssignmentModalActive = false;
            this.reSetData();
        },

        openBulkTruckEventModal() {
            this.isBulkTruckEventModalActive = true;
        },

        closeBulkTruckEventModal() {
            $("#bulk-truck-event-modal").modal('hide');
            this.isBulkTruckEventModalActive = false;
        },

         /**
        * for close escorter modal
        */
        closeEscorterModal() {
            $("#escorter-modal").modal('hide');
            this.isEscorterModalActive = false;
            this.reSetData();
        },

        /**
        * for close truck event modal
        */
        closeTruckEventModal() {
            $("#add-truck-event-modal").modal('hide');
            this.isTruckEventModalActive = false;
            this.reSetData();
        },

        /**
        * for close truck event modal
        */
        closeEventTimelineModal() {
            this.isEventTimelineModalActive = false;
            this.reSetData();
        },

        /**
        * $emit Form datatable select action
        */
        getSelectedRows(data, isSelectedAll) {
            this.selectedTrips = data;
            // this.isContextMenuOpen = data.length > 1;
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;
            let escorter = {
                id: rowData.escorter_id,
                first_name: rowData.escorter_first_name,
                last_name: rowData.escorter_last_name,
                middle_name: rowData.escorter_middle_name,
                category: rowData.escorter_category,
                city: rowData.escorter_city,
                matricule: rowData.escorter_matricule,
                phone: rowData.escorter_phone,
                path: rowData.escorter_photo_path,
            }
            if ([this.$t('delete'), 'Delete'].includes(actionObj.title)) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.TRIP}/${rowData.id}`;
                this.openAddEditModal();
            } else if ([this.$t('assign_device'), this.$t('unassign_device')].includes(actionObj.title)) {
                this.tripDeviceData = {
                    id: rowData.id,
                    lot_number: rowData.lot_number,
                    horse: rowData.horse,
                    active_device_count: rowData.active_device_count,
                    active_device_name: rowData.active_device_name,
                    active_device_imei: rowData.active_device_imei,
                };
                this.openTripDeviceAssignmentModal();
            } else if (actionObj.title == this.$t('escorter')) {
                this.escorterData = {
                    lot_number: rowData.lot_number,
                    horse: rowData.horse,
                    driver_name: rowData.driver_name,
                    driver_number: rowData.driver_number,
                    escorter
                };
                this.openEscorterModal();
            } else if (actionObj.title == this.$t('location')) {
                this.truckData = {
                    trip_id: rowData.id,
                    location_id: rowData.location_id,
                    status_id: rowData.status_id,
                    escorter_id: rowData.escorter_id,
                    lot_number: rowData.lot_number,
                    horse: rowData.horse,
                    driver_name: rowData.driver_name,
                    driver_number: rowData.driver_number,
                    escorter,
                };
                this.openTruckEventModal();
            } else if ([this.$t('lot_number'), this.$t('tracking_timeline')].includes(actionObj.title)) {
                this.timelineData = {
                    trip_id: rowData.id,
                    lot_number: rowData.lot_number,
                    horse: rowData.horse,
                };
                this.openEventTimelineModal();
            }
        },
        getConvoyListAction(rowData, actionObj) {
            this.convoyRowData = rowData;

            if ([this.$t('delete'), 'Delete'].includes(actionObj.title)) {
                this.convoyDeleteConfirmationModalActive = true;
            } else if (actionObj.title == this.$t('edit')) {
                this.openConvoyModal(`${actions.CONVOY}/${rowData.id}`, [], false);
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.TRIP}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#trip-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        confirmedConvoyDelete() {
            let url = `${actions.CONVOY}/${this.convoyRowData.id}`;
            this.convoyDeleteLoader = true;

            this.axiosDelete(url)
                .then(response => {
                    this.convoyDeleteLoader = false;
                    $("#convoy-delete").modal('hide');
                    this.cancelledConvoyDelete();
                    this.$toastr.s(response.data.message);
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                    this.$hub.$emit('reload-' + this.convoyTableId);
                });
        },
        cancelledConvoyDelete() {
            this.convoyDeleteConfirmationModalActive = false;
            this.convoyDeleteLoader = false;
            this.convoyRowData = {};
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
            this.tripDeviceData = {};
            this.timelineData = {};
            this.selectedConvoyUrl = '';
            this.convoyModalTrips = [];
            this.convoyModalReadOnly = false;
        },
    },
    created() {
        this.initializeActiveFiltersFromQuery();
    }
}
</script>

<style scoped>
.trips-index-page__excel-export {
    border-color: #2563eb !important;
    background: #2563eb !important;
    color: #fff !important;
}

.trips-index-page__excel-export:hover,
.trips-index-page__excel-export:focus,
.trips-index-page__excel-export:active {
    border-color: #1d4ed8 !important;
    background: #1d4ed8 !important;
    color: #fff !important;
}
</style>
